import { motion } from 'framer-motion';
import { Activity } from 'lucide-react';
import SectionHead from '@/components/SectionHead';
import { PROGRESS_SKILLS } from '@/data/content';
import { fadeUp, viewportOnce, EASE } from '@/lib/motion';

export default function PlayerProgress() {
  return (
    <section id="progress" className="relative py-24 sm:py-32 bg-night overflow-hidden" data-testid="progress-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHead
          chapter="11"
          eyebrow="Player Progress"
          title={'MEASURED\nDEVELOPMENT.'}
          description="Every ASA player is tracked across six dimensions of development — so parents always know how their player is growing."
          testId="progress-heading"
        />
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <motion.div
            variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce}
            className="glass-card rounded-sm p-8 sm:p-10"
            data-testid="progress-bars"
          >
            <div className="flex items-center justify-between mb-8">
              <span className="text-xs uppercase tracking-[0.3em] text-brand-gold font-semibold">Example Development Profile</span>
              <Activity size={18} className="text-brand-red" />
            </div>
            <div className="space-y-6">
              {PROGRESS_SKILLS.map((s, i) => (
                <div key={s.skill} data-testid={`progress-skill-${s.skill.toLowerCase()}`}>
                  <div className="flex justify-between items-baseline mb-2">
                    <span className="font-display text-lg tracking-widest text-white uppercase">{s.skill}</span>
                    <span className="text-sm font-bold text-brand-gold">{s.level}%</span>
                  </div>
                  <div className="h-1.5 bg-white/10 rounded-full overflow-hidden">
                    <motion.div
                      initial={{ width: 0 }}
                      whileInView={{ width: `${s.level}%` }}
                      viewport={viewportOnce}
                      transition={{ duration: 1.2, delay: i * 0.1, ease: EASE }}
                      className="h-full rounded-full bg-gradient-to-r from-brand-red to-brand-gold"
                    />
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
          <motion.div variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={viewportOnce}>
            <h3 className="font-display text-3xl sm:text-4xl text-white uppercase tracking-wide">Six Dimensions.<br />One Complete Player.</h3>
            <p className="mt-5 text-base sm:text-lg text-gray-400 leading-relaxed max-w-md">
              Technical, tactical, physical, mental, teamwork and leadership — assessed through training observation, match performance and coach feedback.
            </p>
            <div className="mt-8 border-l-2 border-brand-gold pl-5">
              <p className="text-sm text-gray-500 leading-relaxed">
                A full parent dashboard with live player progress tracking is on the ASA roadmap — the structure is built and ready.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
